// extracted by mini-css-extract-plugin
export default {"root":"NotificationBar_root__aQ5i2","text":"NotificationBar_text__PNL11","cta":"NotificationBar_cta__o1TB8"};